import clientConfig from '../client/config';
import { SIZE_136_136 } from '../constants/imageTemplateStrings';

export const makePhotoUrl = (photo?: string | null, template?: string) =>
  photo
    ? `${clientConfig.imageServiceUrl}${photo}${
        template ? `?template=${template}` : ''
      }`
    : undefined;

export const makePhotoUrlFromAbsoluteUrl = (
  photoUrl: string,
  template: string | null = SIZE_136_136,
) => {
  let url = photoUrl;
  if (template) {
    url = `${url}?template=${template}`;
  }

  return url;
};
